import { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SettingsIcon from '@mui/icons-material/Settings';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import { useNavigate } from "react-router";
import styles from "../assests/scss/themes-vars.module.scss";
import { AuthLogout } from "../../redux/actionCreators/authActions";
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import userGuidelinesPDF from '../assests/docs/Innovate_User_Guidelines.pdf';
import {Typography } from "@mui/material";

const NavbarProfileMenu = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const doLogout = () => {
    dispatch(AuthLogout());
    navigate("/");
  }
  const handleChangePassword = () => {
    navigate("change-password-form");
    handleClose();
  }

  const handleChangeCurrency = () => {
    navigate("change-currency-form");
    handleClose();
  }

  const handleSetting = () => {
    setOpen(!open);
  };

  return (
    <>
      <IconButton onClick={handleClick} color="inherit" size="small" sx={{ backgroundColor: styles.hIconbgColor, color: styles.hIconColor }}>
        <PersonIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleSetting}>
          <SettingsIcon fontSize="small" sx={{ marginX: "4px" }} />
          Settings
          {open ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" >
            <MenuItem sx={{ pl: 4 }} onClick={handleChangePassword} ><SyncLockIcon fontSize="small" sx={{ marginX: "4px" }} />Change Password</MenuItem>
            <MenuItem sx={{ pl: 4 }} onClick={handleChangeCurrency} ><SyncLockIcon fontSize="small" sx={{ marginX: "4px" }} />Set Currency</MenuItem>
          </List>
        </Collapse>
        <MenuItem>
            <Typography component="a" href={userGuidelinesPDF} target="_blank" sx={{textDecoration:'none', color:'#121212 !important', display: 'flex', alignItems: 'center'}}>
                <FileDownloadIcon fontSize="small" sx={{ marginX: "4px" }} /> User Guidelines
              </Typography>
        </MenuItem>
        <MenuItem onClick={doLogout}><LogoutIcon fontSize="small" sx={{ marginX: "4px" }} />Logout</MenuItem>
      </Menu>
    </>
  );
};

export default NavbarProfileMenu;
